import axios from 'axios';
import attachAuthToken from './axiosConfig';

/**
 * Grupos de Acesso (at-81, ADR 0044) — ADMIN/TI.
 *
 * ⚠️ SEM nenhum catch, de propósito (regra da at-60): "não existe grupo nenhum" e "não consegui
 * perguntar" levam a conclusões opostas — a primeira convida a criar o primeiro grupo, a segunda
 * significa que a tela não sabe o que existe. Quem distingue é a tela.
 */
const gruposApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/grupos-de-acesso`,
  withCredentials: true,
});

attachAuthToken(gruposApi);

export interface GrupoDeAcesso {
  id: string;
  nome: string;
  descricao: string | null;
  telaInicial: string | null;
  prioridade: number;
  ativo: boolean;
  papeis: string[];
  /** Nomes de exibição prontos do backend — derivar aqui faria os dois lados divergirem. */
  papeisRotulos: string[];
  quantidadeUsuarios: number;
}

export interface GrupoDeAcessoDetalhe extends GrupoDeAcesso {
  usuarios: Array<{ id: string; nome: string; ativo: boolean }>;
}

export interface TelaInicialDisponivel {
  path: string;
  rotulo: string;
}

export interface GrupoDeAcessoPayload {
  nome: string;
  descricao?: string;
  papeis: string[];
  telaInicial?: string | null;
  prioridade?: number;
  ativo?: boolean;
}

export async function listarGruposDeAcesso(): Promise<GrupoDeAcesso[]> {
  const { data } = await gruposApi.get('');
  return data;
}

export async function buscarGrupoDeAcesso(id: string): Promise<GrupoDeAcessoDetalhe> {
  const { data } = await gruposApi.get(`/${id}`);
  return data;
}

export async function listarTelasIniciais(): Promise<TelaInicialDisponivel[]> {
  const { data } = await gruposApi.get('/telas-iniciais');
  return data;
}

export async function criarGrupoDeAcesso(payload: GrupoDeAcessoPayload): Promise<GrupoDeAcesso> {
  const { data } = await gruposApi.post('', payload);
  return data;
}

export async function atualizarGrupoDeAcesso(
  id: string,
  payload: Partial<GrupoDeAcessoPayload>,
): Promise<GrupoDeAcesso> {
  const { data } = await gruposApi.patch(`/${id}`, payload);
  return data;
}

export async function excluirGrupoDeAcesso(id: string): Promise<void> {
  await gruposApi.delete(`/${id}`);
}

export async function definirUsuariosDoGrupo(
  id: string,
  usuarioIds: string[],
): Promise<GrupoDeAcessoDetalhe> {
  const { data } = await gruposApi.put(`/${id}/usuarios`, { usuarioIds });
  return data;
}
